import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2, Gift } from "lucide-react";
import { MarketingPage } from "../../components/smartreach/Chrome";
import { sr } from "../../lib/sr";

export default function Redeem() {
  const { code } = useParams();
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    (async () => {
      try {
        const info = await sr.redeemInfo(code);
        if (!info.valid) { setState({ loading: false, valid: false }); return; }
        const r = await sr.redeem(code);
        setState({ loading: false, valid: true, business: r.business_name, offer: r.offer });
      } catch {
        setState({ loading: false, valid: false });
      }
    })();
  }, [code]);

  return (
    <MarketingPage>
      <section className="sr-section"><div className="sr-wrap" style={{ maxWidth: 560, textAlign: "center" }}>
        {state.loading ? (
          <div className="sr-empty"><Loader2 className="sr-spin" size={28} /><p style={{ marginTop: 10 }}>Recording your offer…</p></div>
        ) : state.valid ? (
          <div className="sr-card sr-fade" data-testid="redeem-success">
            <CheckCircle2 size={44} color="var(--success)" style={{ margin: "0 auto" }} />
            <h1 style={{ fontSize: 30, marginTop: 14 }}>You're all set!</h1>
            <p className="sr-muted" style={{ marginTop: 10, fontSize: 17 }}>
              Show this screen at {state.business || "the business"}.
            </p>
            {state.offer && (
              <div className="sr-card" style={{ marginTop: 18, background: "var(--blue-light)", border: "1px solid var(--blue)" }}>
                <Gift size={22} color="var(--blue)" />
                <strong style={{ display: "block", color: "var(--navy)", marginTop: 8, fontSize: 18 }}>{state.offer}</strong>
              </div>
            )}
            <p className="sr-muted" style={{ fontSize: 12, marginTop: 16 }}>Code: {code} · redemption recorded</p>
          </div>
        ) : (
          <div className="sr-card" data-testid="redeem-invalid">
            <XCircle size={44} color="var(--danger)" style={{ margin: "0 auto" }} />
            <h1 style={{ fontSize: 26, marginTop: 14 }}>This offer link isn't valid</h1>
            <p className="sr-muted" style={{ marginTop: 10 }}>Please check the code and try again.</p>
          </div>
        )}
      </div></section>
    </MarketingPage>
  );
}
